import { createContext, type ReactNode, useContext, useState } from "react";
import type { Id } from "../../../../convex/_generated/dataModel";

type Config = {
	selected: Id<"mailMessages"> | null;
};

type MailContextValue = [Config, (next: Config) => void];

const MailContext = createContext<MailContextValue | null>(null);

export function MailProvider({ children }: { children: ReactNode }) {
	const state = useState<Config>({ selected: null });
	return <MailContext.Provider value={state}>{children}</MailContext.Provider>;
}

export function useMail(): MailContextValue {
	const ctx = useContext(MailContext);
	if (!ctx) throw new Error("useMail must be used within MailProvider");
	return ctx;
}
